import { create } from "zustand";

export type AuthState = {
  isGettingUser: boolean;
  isAuthenticated: boolean;
  errorMessage: string;
  showLogin: boolean;
};

type AuthApiError = { message?: string; status?: number };

type AuthStore = AuthState & {
  beginSession: () => void;
  finishSession: () => void;
  getUserFail: (err: AuthApiError) => void;
  logout: () => void;
};

export const initialAuthState: AuthState = {
  isGettingUser: false,
  isAuthenticated: false,
  errorMessage: "",
  showLogin: false,
};

export const useAuthStore = create<AuthStore>((set) => ({
  ...initialAuthState,
  beginSession: () =>
    set({
      isAuthenticated: true,
      isGettingUser: true,
      errorMessage: "",
      showLogin: false,
    }),
  finishSession: () => set({ isGettingUser: false, errorMessage: "" }),
  getUserFail: (err) =>
    set({
      errorMessage: err.message || "Please try again later.",
      isGettingUser: false,
      showLogin: err.status === 401,
    }),
  logout: () => set(initialAuthState),
}));
